import { FIELD_MAPPINGS } from './constants';
import { normalizeCellToString } from '../../utils/readXlsxFile.utils';

export const fieldNormalizers = Object.keys(FIELD_MAPPINGS).reduce<Record<string, Function>>((acc, key) => {
  acc[key] = normalizeCellToString;
  return acc;
}, {});
